
        import { injectStyle } from '__style_helper__'
        injectStyle("[data-visible=false]{visibility:hidden}.visually-hidden{clip:rect(0 0 0 0);border:0;width:1px;height:1px;margin:-1px;padding:0;position:absolute;overflow:hidden}")

        export default {}
        